import BrandMark from '../../components/BrandMark';
import GlitchTitle from '../../components/GlitchTitle';
import IsoCube from '../../components/IsoCube';
import styles from './ScreenNoSessionView.module.css';

export type ScreenStandbyVariant = 'no-session' | 'game-idle';

const COPY: Record<
  ScreenStandbyVariant,
  { sr: string; eyebrow: string; title: string; sub: string }
> = {
  'no-session': {
    sr: 'Massimo schermo in attesa: nessuna sessione evento attiva.',
    eyebrow: 'CI SIAMO QUASI',
    title: 'ATTENDERE…',
    sub: 'NESSUNA SESSIONE EVENTO ATTIVA',
  },
  'game-idle': {
    sr: 'Massimo schermo: gara in pausa tra un round e l\'altro.',
    eyebrow: 'ROUND CONCLUSO',
    title: 'GARA NON ATTIVA',
    sub: 'IN ATTESA DELLA REGIA PER IL PROSSIMO ROUND',
  },
};

interface ScreenNoSessionViewProps {
  /** `game-idle` = sessione agganciata ma `game_state` in IDLE dopo i risultati. */
  variant?: ScreenStandbyVariant;
}

/**
 * Schermata maxi di attesa: nessuna sessione (`/screen` senza evento) oppure
 * pausa tra round (`variant="game-idle"`).
 */
export default function ScreenNoSessionView({ variant = 'no-session' }: ScreenNoSessionViewProps) {
  const c = COPY[variant];
  return (
    <div className={styles.shell}>
      <p className={styles.sr}>{c.sr}</p>
      <div className={styles.root}>
        <BrandMark tone="light" className={styles.brand} />

        <div className={styles.center}>
          <span className={styles.identity}>
            <span className={styles.identityDot} aria-hidden />
            {c.eyebrow}
          </span>

          <div className={styles.cubeWrap}>
            <IsoCube uid={variant === 'game-idle' ? 'screen-game-idle' : 'screen-nosession'} className={styles.cube} />
          </div>

          <GlitchTitle text={c.title} className={styles.title} as="h1" />

          <div className={styles.progress} aria-hidden>
            {[0, 1, 2, 3, 4].map((i) => (
              <span
                key={i}
                className={styles.progressBar}
                style={{ animationDelay: `${i * 220}ms` }}
              />
            ))}
          </div>

          <div className={styles.subline}>
            <span className={styles.sublineLabel}>{c.sub}</span>
          </div>

          {variant === 'game-idle' ? (
            <aside className={styles.selfieCallout} aria-label="Selfie con Andromeda">
              <div className={styles.selfieQrFrame}>
                <img
                  src="/ipb-selfie.png"
                  alt="QR code: apri il selfie con Andromeda sul telefono"
                  className={styles.selfieQr}
                  width={140}
                  height={140}
                  decoding="async"
                />
              </div>
              <p className={styles.selfieCalloutText}>
                Nel frattempo, scattati un selfie con{' '}
                <span className={styles.selfieCalloutAccent}>Andromeda</span>!
              </p>
            </aside>
          ) : null}
        </div>
      </div>
    </div>
  );
}
